module.exports = __webpack_public_path__ + "assets/img/driver-btn-6dffc923.png";